import BaseForm from "form-backend-validation";

export default class Form extends BaseForm {

    constructor(data = {}, options = {}) {

        if (!options.hasOwnProperty('resetOnSuccess')) {
            options.resetOnSuccess = false;
        }

        super(data, options);
    }

    /**
     * Check if the form data has been changed.
     *
     * @returns {boolean}
     */
    get isDirty() {
        return !Object.keys(this.initial).reduce((carry, item) => {
            return carry && _.isEqual(this.initial[item], this[item]);
        }, true);
    }
}
